<span class="mode-switch"
  [class.disabled]="disabled"
  [class.toggle-enabled]="toggleState"
  (click)="modeSwitch(!toggleState)">
  <span class="toggle-label" *ngIf="label">{{ label | translate }}</span>
  <span class="toggle-icon">
    <i class="far fa-toggle-large-on" [class.is-hidden]="!toggleState"></i>
    <i class="far fa-toggle-large-off" [class.is-hidden]="toggleState"></i>
  </span>
</span>
